import type { ProductSalesViewScope } from '../hooks/useProductSalesScope';

export type SalesTrendValue = 'increase' | 'decrease';

function readSalesTrend(
    request: object | null | undefined,
    field: string,
): SalesTrendValue | null {
    if (!request || !(field in request)) {
        return null;
    }

    const value = Reflect.get(request, field);
    if (value === 'increase' || value === 'decrease') {
        return value;
    }

    return null;
}

export function getSalesTrendForView(
    request: object | null | undefined,
    scope: ProductSalesViewScope,
): SalesTrendValue | null {
    const scopedField = scope === 'wide' ? 'zoneSalesTrend' : 'storeSalesTrend';
    const scopedTrend = readSalesTrend(request, scopedField);
    if (scopedTrend) {
        return scopedTrend;
    }

    return readSalesTrend(request, 'salesTrend');
}
